import { ITokenInfo } from "~/types/global"
import { IRecommendedPerson } from "~/types/priority"
import { axiosInstance } from "~/utils/axios"

export async function addToYourPeopleList(
  tokenInfo: ITokenInfo,
  data: {
    person_id?: number
    linkedin_urls?: string[]
    account_id?: number | null
  },
  linkedTenantId?: number
) {
  let url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/add-to-your-people-list`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data
  })
}

export async function getPeopleByIds(
  tokenInfo: ITokenInfo,
  ids: number[]
): Promise<{
  data: { success: boolean; data: { data: Partial<IRecommendedPerson>[] } }
}> {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/people/by-ids`,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: { ids }
  })
}

export async function downloadYourPeopleList(
  tokenInfo: ITokenInfo,
  data: Record<string, unknown>
) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/download-your-people-list`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    responseType: "blob",
    data
  })
}
